<template>
    <div class="caja-padre">
        <div class="contenedor" :style="{ backgroundImage: ` linear-gradient(450deg, #333346, #272650)` }">
            <div style="display: flex;justify-content: space-between;">
                <div @click="jackpotinfo"><svg width="24px" height="24px" viewBox="-6.06 -6.06 72.72 72.72"
                        xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/"
                        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg"
                        version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                        <g id="SVGRepo_bgCarrier" stroke-width="0">
                            <rect x="-6.06" y="-6.06" width="72.72" height="72.72" rx="36.36" fill="#ffffff"
                                strokewidth="0"></rect>
                        </g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                            <defs></defs>
                            <metadata>
                                <rdf:rdf>
                                    <cc:work rdf:about="">
                                        <dc:format>image/svg+xml</dc:format>
                                        <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"></dc:type>
                                        <dc:title>情報コーナー; Information</dc:title>
                                        <dc:source>
                                            http://www.ecomo.or.jp/barrierfree/pictogram/data/zukigo_panfu_jis110.pdf
                                        </dc:source>
                                    </cc:work>
                                </rdf:rdf>
                            </metadata>
                            <path
                                d="m 0,0 c 0,12.079 -9.793,21.872 -21.872,21.872 -12.079,0 -21.871,-9.793 -21.871,-21.872 0,-12.079 9.792,-21.872 21.871,-21.872 C -9.793,-21.872 0,-12.079 0,0 Z"
                                style="stroke-linejoin:miter;stroke-opacity:1;fill-opacity:1;stroke:#000000;stroke-linecap:butt;stroke-miterlimit:4;stroke-dasharray:none;stroke-width:0.48500001;fill:#ffffff"
                                transform="matrix(0.000000,1.250000,1.250000,0.000000,30.300503,57.639880)"></path>
                            <path
                                d="m 34.961753,47.76613 0,-23.573752 -13.182501,0 0,2.575 3.85875,0 0,20.998752 -3.85875,0 0,2.57375 17.041251,0 0,-2.57375 -3.85875,0"
                                style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"></path>
                            <path
                                d="m 30.299253,21.526128 c 3.1975,0 5.78875,-2.59125 5.78875,-5.78875 0,-3.197501 -2.59125,-5.7900009 -5.78875,-5.7900009 -3.19875,0 -5.79,2.5924999 -5.79,5.7900009 0,3.1975 2.59125,5.78875 5.79,5.78875"
                                style="fill:#000000;fill-opacity:1;fill-rule:nonzero;stroke:none"></path>
                        </g>
                    </svg></div>
                <button @click="openclosedmodal" style="background-color: #fff;"
                    class="btn-close btn-outline-light"></button>
            </div>
            <div style="display: flex;justify-content: center;margin-bottom: 20px;">
                <div class="prueba"
                    style="letter-spacing: 5px; font-family: 'Impact','Arial'; font-size: 80px;font-weight: bold;text-shadow: 4px 4px 0px #ececec, 8px 8px 0px rgba(233, 233, 233, 0.5);"
                    :style="{ color: skin.main_modal_background }">
                    JACKPOT</div>
            </div>
            <div v-if="jackpot.length === 0">
                <p class="no-jackpot">Estos son los jackpots activos en este momento.</p>
            </div>
            <!-- Mostrar mensaje de error si ocurre un problema al reclamar el premio -->
            <div v-if="errorMessage" class="error-message">
                <p>{{ errorMessage }}</p>
            </div>
            <div v-if="errorMessage1" class="error-message">
                <p v-html="errorMessage1"></p>
            </div>
            <div v-if="!showCoins && jackpot && !errorMessage && !errorMessage1">
                <div v-for="(jackpotItem, index) in jackpot" :key="index" class="bars">
                    <div class="progress-bar-wrapper" :style="{ marginLeft: `${index * 10}%` }"
                        :class="{ 'blink': jackpotItem.porcentaje === 100, 'clickable': jackpotItem.porcentaje === 100 }"
                        @click="jackpotItem.porcentaje == 100 && jackpot_claim(jackpotItem.id)">
                        <div class="progress-bar" :style="{ animation: `progress-${index} 4s forwards` }">
                            <span v-if="jackpotItem.porcentaje == 100" class="progress-text1">Reclama!! {{ '$' + new
                                Intl.NumberFormat("de-DE", {
                                    minimumFractionDigits:
                                        skin.qBet_config.decimalsQty, maximumFractionDigits:
                                        skin.qBet_config.decimalsQty
                                }).format(jackpotItem.tope) }} </span>
                            <span v-else class="progress-text"
                                :class="{ 'text-transition': jackpotItem.porcentaje > 50 }">{{ '$' + new
                                    Intl.NumberFormat("de-DE", {
                                        minimumFractionDigits:
                                            skin.qBet_config.decimalsQty, maximumFractionDigits:
                                            skin.qBet_config.decimalsQty
                                    }).format(jackpotItem.tope) }} </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="prizeAmount" class="coins-container">
                <div v-for="(coin, index) in coins" :key="index" class="coin" :style="coinStyle(coin)"></div>
                <div class="prize-result">🎉 ¡{{ prizeAmount }}! 🎉</div>
            </div>

        </div>

    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'ModalJackpot',
    props: ["skin"],
    data() {
        return {
            jackpot: [],
            coins: [],
            showCoins: false,
            prizeAmount: "",
            errorMessage: "",
            errorMessage1: "",
        };
    },
    computed: {
        user() {
            return this.$store.getters['getUserData'];
        },
    },
    methods: {
        jackpotinfo() {
            if (this.errorMessage1 == "") {
                this.errorMessage1 = `
        Juega los juegos de las marcas con el ícono de Jackpot 
        <svg fill="#000000" width="40px" height="40px" viewBox="-1.4 -1.4 16.80 16.80" role="img" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0" transform="translate(1.54,1.54), scale(0.78)"><rect x="-1.4" y="-1.4" width="16.80" height="16.80" rx="8.4" fill="#dbba00" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="m 12.324082,8.1685 -0.05633,0.1972 -0.211224,0.063 -0.213551,0.066 0.211224,0.061 0.211225,0.063 0.06098,0.2113 0.06098,0.2088 0.06575,-0.2112 0.06343,-0.2135 0.19947,-0.054 c 0.108,-0.03 0.190163,-0.063 0.178408,-0.073 -0.0094,-0.01 -0.08914,-0.035 -0.173633,-0.059 -0.08682,-0.021 -0.168979,-0.047 -0.183061,-0.056 -0.01408,-0.01 -0.04922,-0.096 -0.07739,-0.1925 -0.02816,-0.094 -0.05633,-0.1831 -0.06576,-0.1925 -0.0095,-0.01 -0.04004,0.07 -0.07053,0.1808 z M 1.483429,7.2203 C 1.413019,7.462 1.415349,7.455 1.382531,7.4668 c -0.01641,0 -0.110327,0.033 -0.206572,0.061 L 1,7.5818 1.197143,7.6428 c 0.110326,0.035 0.206571,0.078 0.218326,0.096 0.0094,0.019 0.04224,0.1126 0.07041,0.2089 l 0.05167,0.1761 0.05865,-0.1925 c 0.03282,-0.1057 0.07041,-0.2018 0.07984,-0.2112 0.01176,-0.01 0.105673,-0.045 0.211224,-0.078 L 2.079753,7.5811 1.892039,7.5271 C 1.788814,7.4961 1.694896,7.4641 1.680814,7.4521 1.669054,7.4401 1.629144,7.3418 1.596324,7.2362 L 1.535094,7.0437 1.483424,7.2197 Z M 5.623551,5.9365 C 5.316082,6.0398 4.952286,6.3379 4.839633,6.582 l -0.05633,0.122 -0.335633,0 -0.335632,0 L 3.75767,6.9834 C 2.929181,7.6359 2.497303,8.0935 2.236854,8.6004 2.023303,9.0182 1.955221,9.4241 2.030283,9.849 l 0.02584,0.1526 1.037388,0.01 1.037388,0 0.02584,-0.1338 C 4.245879,9.4248 4.457106,8.9484 4.757596,8.5188 4.921922,8.2841 4.940657,8.2466 4.978249,8.0636 5.104984,7.4557 5.464126,6.7586 5.949882,6.1743 6.083718,6.0147 6.118861,5.9607 6.095351,5.9467 6.029591,5.9087 5.7198,5.9047 5.623555,5.9347 Z M 12.432082,4.918 c -0.06808,0.075 -0.347388,0.2089 -0.521021,0.2511 -0.201796,0.049 -0.699428,0.052 -0.941143,0 L 10.798612,5.1361 10.582735,5.3614 C 10.324612,5.629 10.148531,5.8285 9.967796,6.0655 l -0.133714,0.1737 0.206571,0.066 c 0.227633,0.075 0.504612,0.1337 0.661837,0.1431 l 0.103224,0.01 L 10.432612,6.74 C 9.730857,7.2681 9.12302,7.8148 8.939959,8.0801 c -0.08216,0.1197 -0.180735,0.596 -0.201796,0.988 -0.01641,0.2722 0.0023,0.8449 0.02816,0.9153 0.0094,0.026 0.255795,0.03 1.377673,0.03 1.288531,0 1.363592,0 1.347184,-0.042 C 11.41612,9.7812 11.333955,9.4926 11.301016,9.3095 11.249346,9.0044 11.265746,8.3543 11.336286,8.0586 11.531102,7.2207 11.993469,6.4509 12.753878,5.6975 L 13,5.4536 12.739429,5.1625 C 12.596286,5.0053 12.478857,4.8739 12.476531,4.8739 c -0.0023,0 -0.02339,0.021 -0.04445,0.045 z m -11.162204,0.8355 0,0.9739 0.455265,0 c 0.431877,0 0.457714,0 0.471796,-0.044 0.02351,-0.075 0.345061,-0.3615 0.485877,-0.4319 0.07273,-0.038 0.187715,-0.073 0.262898,-0.08 l 0.131388,-0.014 0,-0.6806 0,-0.6806 -0.194816,0.012 c -0.131388,0.01 -0.241715,0.033 -0.347388,0.075 -0.08449,0.033 -0.176082,0.061 -0.204122,0.061 -0.06098,0 -0.122082,-0.059 -0.122082,-0.1197 0,-0.042 -0.02106,-0.045 -0.469347,-0.045 l -0.469469,0 0,0.9741 z m 2.065346,-0.6806 0,1.3729 0.640776,0 0.638327,0 0.0469,-0.082 C 4.719877,6.2535 5.015595,5.9742 5.194003,5.8592 5.597717,5.5965 5.900411,5.5893 6.635105,5.8242 7.095146,5.9697 7.346289,6.026 7.616166,6.0448 l 0.229959,0.014 -0.396734,0.2981 c -0.852,0.6336 -1.488,1.1687 -1.891592,1.5889 -0.849551,0.8848 -1.227429,1.7062 -1.182857,2.5699 0.0094,0.1572 0.03049,0.3474 0.0469,0.4248 l 0.03049,0.1408 2.189755,0.01 c 1.750898,0 2.187306,0 2.178,-0.023 C 8.587801,10.5378 8.477474,9.9887 8.475148,9.3667 8.472848,7.8506 9.174576,6.3932 10.566332,5.0155 L 10.934781,4.6517 10.573311,4.248 C 10.373842,4.025 10.204862,3.8443 10.19776,3.8443 c -0.0071,0 -0.05865,0.038 -0.110326,0.084 C 9.95127,4.0456 9.653229,4.1841 9.402087,4.2475 9.219025,4.2945 9.132209,4.3015 8.744903,4.2995 8.155801,4.2995 7.975066,4.2645 6.949434,3.9662 5.989556,3.6845 5.569434,3.6634 5.060168,3.8653 4.961598,3.9053 4.855923,3.9383 4.82776,3.9383 4.75735,3.9383 4.672862,3.8443 4.672862,3.767 l 0,-0.063 -0.668939,0 -0.668938,0 0,1.3731 z M 5.801837,4.1834 c 0.05633,0.068 -0.0047,0.1127 -0.183061,0.1409 -0.08914,0.012 -0.227633,0.049 -0.30747,0.077 -0.154898,0.059 -0.215877,0.045 -0.215877,-0.044 0,-0.061 0.04922,-0.092 0.239387,-0.1549 0.204245,-0.066 0.420123,-0.075 0.467021,-0.019 z m 0.267551,6.4049 0,0.07 -0.612612,0.01 c -0.657184,0.01 -0.69,0 -0.654858,-0.1127 0.01408,-0.047 0.02584,-0.047 0.640653,-0.042 l 0.626694,0.01 0,0.07 z M 8.827061,3.0826 c -0.02816,0.1009 -0.06331,0.1948 -0.07984,0.2089 -0.01408,0.014 -0.09392,0.045 -0.178408,0.068 -0.234734,0.063 -0.237061,0.07 -0.01408,0.1314 l 0.204122,0.056 0.06343,0.2112 0.06588,0.2089 0.054,-0.1854 c 0.03049,-0.1032 0.06331,-0.1994 0.07506,-0.2112 0.01176,-0.014 0.110327,-0.052 0.215878,-0.084 L 9.425593,3.4254 9.249511,3.3734 C 9.153271,3.3454 9.059348,3.3144 9.040613,3.3054 9.021883,3.2954 8.981963,3.2045 8.953793,3.1012 8.923303,3.0003 8.895143,2.9134 8.890363,2.9087 c -0.0045,0 -0.03269,0.075 -0.06331,0.1737 z"></path></g></svg>
        y mira cómo crece la barra con cada jugada. ¡Cuando se llene, recibirás saldo extra para seguir apostando a lo grande! 💰💥
      `;
            }
            else {
                this.errorMessage1 = "";
            }
        },
        openclosedmodal() {
            this.$emit("openclosedmodal");
        },
        async jackpots_active() {
            if (!this.user?.domain || !this.user?.token) {
                console.log(this.user)
                console.error("El usuario no tiene dominio o token válido.");
                return;
            }

            const data = {
                command: "jackpots_active",
                params: {},
            };

            try {
                const response = await axios.post(
                    `${this.user.domain}/api/scommand?access_token=${this.user.token}`,
                    data
                );
                if (response.data.status === "success") {
                    this.jackpot = response.data.data
                        .filter(jackpotItem => !jackpotItem.payed)
                        .map(jackpotItem => ({
                            ...jackpotItem,
                            porcentaje: jackpotItem.tope > 0
                                ? (jackpotItem.valor * 100) / jackpotItem.tope
                                : 0
                        }))
                        .sort((a, b) => b.tope - a.tope);

                    console.log(this.jackpot);
                } else {
                    console.error("Error en la respuesta:", response.data.message);
                }
            } catch (error) {
                console.error("Error en la solicitud:", error);
            }
        },
        async jackpot_claim(id) {
            if (!this.user?.domain || !this.user?.token) return;
            const data = { command: "jackpot_claim", params: { "jackpotId": id } };
            try {
                const response = await axios.post(`${this.user.domain}/api/scommand?access_token=${this.user.token}`, data);
                if (response.data.status === "success") {
                    this.prizeAmount = response.data.data.msg;
                    this.showCoins = true;
                    this.dropCoins();
                }
                else {
                    console.log(response.data);
                    this.errorMessage = response.data.data.msg || "Ocurrió un error al reclamar el premio.";

                }

            } catch (error) { console.error("Error en la solicitud:", error); }
        },
        dropCoins() {
            this.coins = [];
            let interval = setInterval(() => {
                if (this.coins.length > 50) this.coins.shift();
                this.coins.push({ left: Math.random() * 100, duration: 2 + Math.random() * 3, size: 20 + Math.random() * 20 });
            }, 100);
            setTimeout(() => clearInterval(interval), 3000);
        },
        formatCurrency(value) {
            return `$${new Intl.NumberFormat("de-DE", { minimumFractionDigits: this.skin.qBet_config.decimalsQty, maximumFractionDigits: this.skin.qBet_config.decimalsQty }).format(value)}`;
        },
        coinStyle(coin) {
            return { left: `${coin.left}%`, width: `${coin.size}px`, height: `${coin.size}px`, animation: `fall ${coin.duration}s linear forwards` };
        }
    },
    mounted() {
        this.jackpots_active().then(() => {
            this.jackpot.forEach((jackpotItem, index) => {
                const style = document.createElement("style");
                style.innerHTML = `
        @keyframes progress-${index} {
          0% { width: 0%; }
          100% { width: ${jackpotItem.porcentaje}%; }
        }
      `;
                document.head.appendChild(style);
            });
        });
    },
}
</script>
<style>
.clickable {
    cursor: pointer;
}

@keyframes fadeToBlack {
    0% {
        color: white;
    }

    100% {
        color: black;
    }
}

.text-transition {
    animation: fadeToBlack 2s ease-in-out forwards;
}

.no-jackpot {
    text-align: center;
    font-size: 18px;
    color: white;
    background: #e0dfff33;
    padding: 10px;
    border-radius: 5px;
    margin: 20px;
}

.error-message {
    text-align: center;
    font-size: 18px;
    color: white;
    background: #e0dfff33;
    padding: 10px;
    border-radius: 5px;
    margin: 20px;
}

.coins-container {
    position: relative;
    height: 300px;
    overflow: hidden;
}

.coin {
    position: absolute;
    top: -50px;
    background: radial-gradient(circle, gold, #b8860b);
    border-radius: 50%;
    box-shadow: 0 0 10px rgba(255, 215, 0, 0.8);
    animation: fall linear infinite;
}

@keyframes fall {
    from {
        transform: translateY(-50px) rotate(0deg);
        opacity: 1;
    }

    to {
        transform: translateY(100vh) rotate(360deg);
        opacity: 0;
    }
}

.prize-result {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    color: #ffd700;
    text-shadow: 2px 2px 10px rgba(255, 215, 0, 0.8);
    margin-top: 20px;
}


.blink {
    animation: blink 0.5s infinite alternate;
}

@keyframes blink {
    from {
        opacity: 1;
    }

    to {
        opacity: 0.7;
    }
}

/* .blink-button {
    animation: blink 1s infinite;
    transition: all 0.3s ease-in-out;
    background: linear-gradient(45deg, #ff0000, #8b0000);
    color: white;
    font-size: 18px;
    width: 30%;
    justify-content: center;
    height: 40px;
    display: flex;
    align-items: center;
    border-radius: 12px;
    font-weight: bold;
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.8);
    cursor: pointer;
}

.blink-button:hover {
    transform: scale(1.15);
    box-shadow: 0 0 15px rgba(255, 0, 0, 1);
} */

.bars {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.progress-bar-wrapper {
    position: relative;
    display: flex;
    height: 50px;
    justify-content: flex-end;
    margin-bottom: 20px;
    border: 1px solid #fff;
    box-shadow: 0 0 4px #aaa;
    padding: 5px;
    transform: skewX(20deg);
    position: relative;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background: linear-gradient(to bottom, gold, #c85, gold);

    box-shadow: 0 0 10px 2px orange;

    transition: width 1s ease-in-out;
    direction: rtl;
}

.progress-text1 {
    font-size: 18px;
    font-weight: bold;
    color: black !important;
    transform: skewX(-20deg);
}

.progress-text {
    position: absolute;
    left: 50%;
    font-size: 18px;
    font-weight: bold;
    transform: skewX(-20deg);
}


* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}


.caja-padre {
    width: 40%;
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
}

.contenedor {
    width: 100%;
    padding: 30px 30px 50px;
    border: 2px solid rgba(0, 0, 0, 0.06);
    border-radius: 20px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
}

.contenedor * {
    font-family: "segoe ui", sans-serif;
    font-weight: 500;
}


@media (max-width: 600px) {
    .caja-padre {
        width: 80%;
        /* Cambia el ancho */
    }

    .prueba {
        font-size: 60px !important;
    }
}
</style>
